// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { BaseResponseVoid } from '../../../types';

export interface PutDataByIdCustomFieldsBody {
    customFieldList: {
        /** id */
        id: string;
        /** value */
        value: string;
    }[];
}

export interface PutDataByIdCustomFieldsParam {
    /** id */
    id: number;
}

/**
 * 修改自定义字段
 *
 * @export
 * @tags 通对话管理
 * @link [PUT] /data/{id}/custom-fields
 * @param id
 */
export function putDataByIdCustomFields(
    options: ApiOptions<PutDataByIdCustomFieldsParam, never> & {
        segments: PutDataByIdCustomFieldsParam;
        data: PutDataByIdCustomFieldsBody;
    }
): Promise<BaseResponseVoid> {
    return request<PutDataByIdCustomFieldsBody, PutDataByIdCustomFieldsParam, never>(
        '/data/{id}/custom-fields',
        {
            ...options,
            method: 'put',
            __$requestCalleeName: 'putDataByIdCustomFields',
        }
    );
}

export const meta = [
    { tags: ['通对话管理'], path: '/data/{id}/custom-fields', method: 'put' },
];
